module.exports = __webpack_public_path__ + "media/images/Plane-bfd137af.svg";